module.exports = __webpack_public_path__ + "static/media/shoprite-hero.e0440931.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shoprite-hero.jpg
// module id = 347
// module chunks = 0